module.exports = __webpack_public_path__ + "img/38exp.e8f3e94a.jpg";